import React from 'react'
import {Loader} from '../../utils/misc'
import axios from 'axios'
import {NotificationManager} from 'react-notifications'
import {API_BASE_URL} from '../../constants'
import {getToken} from '../../storage'
import 'react-select/dist/react-select.css';
import Select from 'react-select';
import moment from 'moment'

export default class AddExpense extends React.Component {

  constructor() {
    super()
    this.submit = this.submit.bind(this)
    this.getExpense = this.getExpense.bind(this)
    this.deleteExpense = this.deleteExpense.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.modifyItemState = this.modifyItemState.bind(this)
    this.handleCategoryChange = this.handleCategoryChange.bind(this)
    this.createExpensePromt = this.createExpensePromt.bind(this)
    this.state = { laoded:true, expense:{
      name: "",
      date: new Date(),
      amount:0,
      category: "Others",
      category_ui: {},
      date_ui: moment().format('YYYY-MM-DD'),
      mode: "cash",
      reference: "",
      notes: ""
    }}
  }

  createExpensePromt() {
    return "Create New Category ?"
  }

  componentDidMount() {
    let params = this.props.match.params
    if(typeof params.expense_id !== "undefined") {
      this.setState({mode:'edit'})
      document.title = "Edit Expense " + this.props.match.params.expense_id
      this.getExpense(this.props.match.params.expense_id).then((response)=>{
        if(response.status===200) {
          this.setState({expense: response.data.expense, loading:false})
        }
      }).catch((err)=>{
        this.setState({loading:false})
      })
    }
    else {
        document.title = "Create Expense "
        this.setState({loading:false})
    }

  }

  getExpense(expense_id) {
    return axios({
      url: '/get_expense/?id='+expense_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  handleDateChange(e) {
    this.modifyItemState('date_ui', e.target.value)
    this.modifyItemState('date', moment(e.target.value).format('YYYY-MM-DDThh:mm'))
  }

  handleInputChange(e) {
    this.modifyItemState(e.target.name, e.target.value)
  }

  deleteExpense() {

    let confirmation = window.confirm('You are about to delete this expense !')

    if(confirmation) {
      axios({
        url: '/delete_expense/',
        method: 'post',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          },
          post: {
            'Content-Type': 'multipart/form-data;'
          }
        },
        data: this.state.expense
      }).then((response)=> {
        if(response.status === 200) {
            NotificationManager.success("Deleted Expense successfully")
          setTimeout(()=>{
            this.props.history.push("/expenses/")
          }, 700)
        }
      }).catch((err)=> {
        console.log(err);
      })
    }
  }

  getExpenseCategories (input) {
    return   axios({
        url: '/get_expense_categories/',
        method: 'get',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then((response)=> {
            return {options: response.data.expense_categories}
      }).catch((err)=> {

        return Promise.resolve({ options: [] });
      })
  }

  handleCategoryChange(cat) {

    if(typeof cat !== "undefined" && cat !== null) {
      if(typeof cat.className !== "undefined") {
         this.modifyItemState('category_ui', cat)
         this.modifyItemState('category', cat.value)
      }
      else {
          this.modifyItemState('category_ui', cat.value)
          this.modifyItemState('category', cat.value)
      }
    }
    else {
      this.modifyItemState('category_ui', "")
      this.modifyItemState('category', "")
    }


  }

  submit() {
    this.setState({'submitting':true})
    let apiurl
    if(this.state.mode ==="edit") {
      apiurl  = "/update_expense/"
    }
    else {
      apiurl  = "/create_new_expense/"
    }
    axios({
      url: apiurl,
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state.expense
    }).then((response)=> {
      this.setState({'submitting':false})
      if(response.status === 200) {
        if(this.state.mode === "edit") {
            NotificationManager.success("Updated Expense successfully")
        }
        else {
          NotificationManager.success("Created Expense successfully")
        }

        setTimeout(()=>{
          this.props.history.push("/expenses/")
        }, 700)

      }
    }).catch((err)=> {
      this.setState({'submitting':false})
      if(typeof err.response !== "undefined" && err.response.data !== "undefined") {
        this.setState({errors: err.response.data.errors})
      }

    })
  }

  modifyItemState(key, value) {
    this.setState({errors: undefined})
          let currentState = this.state.expense
          currentState[key] = value
          this.setState({
            expense:currentState
         });
  }

  render() {

    let expense = this.state.expense



    if(typeof expense.category_ui === "undefined") {
     expense['category_ui'] = expense.category
    }

    if(typeof expense.date_ui === "undefined") {
      expense['date_ui'] = moment(expense.date).format('YYYY-MM-DD')
    }

    console.log(expense.date_ui);

    let category = <Select.AsyncCreatable multi={false} value={expense.category_ui} promptTextCreator={this.createExpensePromt} openOnFocus={true}
        onChange={this.handleCategoryChange} valueKey="name" labelKey="value" loadOptions={this.getExpenseCategories} />

    if(!this.state.loading) {
      let pageHeader, deleteBtn

      let submitButton = <button className="btn btn-success" onClick={this.submit}>Save</button>

      if(this.state.submitting) {
        submitButton = <button className="btn btn-success" disabled>Saving..</button>
      }

      if(this.state.mode === "edit") {
        pageHeader = <h3>{"Edit Expense  #" + expense.id}</h3>
        deleteBtn = <button className="btn btn-sm btn-danger" onClick={this.deleteExpense}>Delete Expense</button>
      }
      else {
        pageHeader =  <h3>Add Expense</h3>
      }

      let form = <div className="form-horizontal">

      <div className="form-group">
        <div className="col-sm-2">
        Name
        </div>
        <div className="col-sm-10">
        <input type="text" name="name" className="form-control input-sm" value={expense.name} onChange={this.handleInputChange} />
        </div>
      </div>

      <div className="form-group">
        <div className="col-sm-2">
        Category
        </div>
        <div className="col-sm-10">
        {category}
        </div>
      </div>



      <div className="form-group">
        <div className="col-sm-2">
        Amount
        </div>
        <div className="col-sm-10">
        <input type="text" className="form-control input-sm" name="amount" value={expense.amount} onChange={this.handleInputChange} />
        </div>
      </div>

      <div className="form-group">
        <div className="col-sm-2">
        Date
        </div>
        <div className="col-sm-10">
        <input type="date" className="form-control input-sm" name="date" value={expense.date_ui} onChange={this.handleDateChange} />
        </div>
      </div>

      <div className="form-group">
      <div className="col-sm-2">
      Payment Mode
      </div>
        <div className="col-sm-10">
        <select name="mode" value={expense.mode} className="form-control input-sm" onChange={this.handleInputChange}>
          <option value="cash" >CASH</option>
          <option value="card">CARD</option>
          <option value="cheque">CHEQUE</option>
          <option value="banktransfer">BANK TRANSFER</option>
          <option value="others">Others</option>
        </select>
        </div>
      </div>

      <div className="form-group">
      <div className="col-sm-2">
      Reference
      </div>
      <div className="col-sm-10">
      <input  type="text" name="reference" value={expense.reference} onChange={this.handleInputChange} className="form-control input-sm" />
      </div>
      </div>

      <div className="form-group">
      <div className="col-sm-2">
      Notes
      </div>
       <div className="col-sm-10">
      <textarea name="notes" className="form-control input-sm" value={expense.notes} onChange={this.handleInputChange}></textarea>
       </div>
      </div>


      </div>

      return <div className="container-fluid">
      <section className="medium">
            {pageHeader}
            <ul className="list-inline">
              <li className="pull-right">{deleteBtn}</li>
            </ul>
      </section>
                <div className="row">
                <div className="col-md-6">
                {form}
                <div className="form-group text-right">
                {submitButton}
                </div>
                </div>
                </div>
                  </div>

    }
    else {
      return <div>
          <Loader />
      </div>

    }

  }
}



// WEBPACK FOOTER //
// ./src/components/expense/addexpense.js